/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamDropdownByDiscipline200,
  GetApiV1ExamDropdownByDiscipline401,
  GetApiV1ExamDropdownByDiscipline500,
  GetApiV1ExamDropdownByDisciplineQueryParams,
  GetApiV1ExamDropdownByDisciplineQueryResponse,
} from "../../types/examEvaluationController/GetApiV1ExamDropdownByDiscipline.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1ExamDropdownByDisciplineQueryParamsSchema = z.object({
  disciplineId: z.optional(z.coerce.number().int()),
  teacherEvaluation: z.boolean().default(false),
}) as unknown as ToZod<GetApiV1ExamDropdownByDisciplineQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamDropdownByDiscipline200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1ExamDropdownByDiscipline200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamDropdownByDiscipline401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamDropdownByDiscipline401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamDropdownByDiscipline500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamDropdownByDiscipline500>;

export const getApiV1ExamDropdownByDisciplineQueryResponseSchema = z.lazy(
  () => getApiV1ExamDropdownByDiscipline200Schema,
) as unknown as ToZod<GetApiV1ExamDropdownByDisciplineQueryResponse>;
